<template>
  <div class="monitoringBus">
    <div class="monitoringBus__header">
      <div class="monitoringBus__header__back" @click.stop="goToAllCampaign()">
        <span class="monitoringBus__header__back__icon"><i class="adx-ic_arrow_left"></i></span>
        <span class="monitoringBus__header__back__all medium-title">All Campaign</span>
      </div>
      <div class="monitoringBus__header__title">
        <h1 class="medium-title ellipsis">{{ campaign_title }}</h1>
      </div>
    </div>
    <!-- First Content - Maps -->
    <div class="monitoringBus__overview">
      <div class="monitoringBus__overview__wrapper">
        <div class="monitoringBus__overview__wrapper__title">
          <span class="medium-title bold">Overview</span>
        </div>
        <div class="monitoringBus__overview__wrapper__card">
          <div class="monitoringBus__overview__wrapper__card__normal">
            <div class="color-white space strong"> IN SERVICE </div>
            <div>
              <span class="color-white large-title strong">{{busStatus.in_service}}</span>
              <span class="color-white strong"> OF {{busStatus.total_bus}} BUSES</span>
            </div>
          </div>
          <div class="monitoringBus__overview__wrapper__card__warning">
            <div class="color-white space strong"> OFF SERVICE </div>
            <div>
              <span class="color-white large-title strong">{{busStatus.off_service}}</span>
              <span class="color-white strong"> OF {{busStatus.total_bus}} BUSES</span>
            </div>
          </div>
          <div class="monitoringBus__overview__wrapper__card__outservice">
            <div class="color-white space strong"> OUT OF SERVICE</div>
            <div>
              <span class="color-white large-title strong">{{busStatus.out_of_service}}</span>
              <span class="color-white strong"> OF {{busStatus.total_bus}} BUSES</span>
            </div>
          </div>
        </div>
        <div class="monitoringBus__overview__wrapper__map">
            <GmapMap
                class="adx-map"
                :center="{lat:-6.1944935, lng:106.7643612}"
                :zoom="12"
                map-type-id="terrain"
                ref="mapRef"
                :options="{
                  zoomControl: true,
                  mapTypeControl: true,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false
                }">
              <GmapMarker
                  v-for="(m, index) in markers"
                  :key="index +'gmarker'"
                  :position="m.position"
                  :clickable="true"
                  @mouseover="showTooltip(m, index, true)"
                  @mouseout="showTooltip(m, index, false)"
                  :icon="bus_icon"
                />
              <gmap-info-window style="background-color: '#262626'" class="pop"
                :key="index + 'gmapwindow'"
                v-for="(m, index) in markers"
                :opened="m.window_open"
                :position="m.position"
                :options="{
                  pixelOffset: {
                    width: 0,
                    height: -35
                  }
                }"
              >
              <div class="pop-up" v-if="selectedMarker">
                <div class="item"><h1 class="small-font color-sunrise">{{selectedMarker.label}}</h1></div>
                <div class="detail" v-if="false">
                  <div class="detail__speed">
                    <span class="small-font color-grey">Speed</span>
                    <div class="detail__speed__value">
                      <span class="base-font color-white">{{selectedMarker.speed}}</span>
                      <span class="small-font color-white"> kmh</span>
                    </div>
                  </div>
                  <div class="detail__odometer">
                    <span class="detail__odometer__label micro-font color-grey">Odometer</span>
                    <span class="detail__odometer__value micro-font color-white">{{selectedMarker.odometer | formatNumber}}</span>
                  </div>
                  <div class="detail__distance">
                    <span class="detail__distance__label micro-font color-grey">Distance</span>
                    <span class="detail__distance__value micro-font color-white">{{selectedMarker.distance | formatNumber}} KM</span>
                  </div>
                  <div class="detail__poi">
                    <span class="detail__poi__label micro-font color-grey">POI</span>
                    <span class="detail__poi__value micro-font color-white">{{selectedMarker.poi}}</span>
                  </div>
                </div>
              </div>
              </gmap-info-window>
            </GmapMap>
        </div>
        <div>
        </div>
      </div>
    </div>
    <!-- Second Content - status -->
    <div class="monitoringBus__report">
      <div class="monitoringBus__report__wrapper" >
        <div class="monitoringBus__report__wrapper__vehicle" v-if="false">
          <adx-selectdropdown class="space" :label="`Vehicle ID`" :value="selectedVehicle" :options="markers" />
        </div>
        <div class="monitoringBus__report__wrapper__table">
          <div class="monitoringBus__report__wrapper__table__content">
            <div>
              <table>
                <thead class="none">
                  <tr>
                    <td class="issue header-1">VEHICLE ID</td>
                    <td class="issue header-3">ROUTES</td>
                    <td class="issue header-4">PLACEMENTS</td>
                    <td class="issue header-5">STATUS</td>
                  </tr>
                </thead>
                <tbody >
                  <tr v-for="(item, index) in listingDisplayed" :key="index" class="content">
                    <td class="id">{{item.vehicle_id}}</td>
                    <td class="id">{{item.routes}}</td>
                    <td class="id">{{item.placements}}</td>
                    <td>
                      <adx-labelstatus class="dropdownDoc__item" :progress='item.status'/>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="loading" v-if="loadingListing">
              <adx-loading />
              </div>
              <div class="empty" v-else-if="isEmpty">
              <adx-empty :subtitle="` `"/>
              </div>
            </div>
          </div>
        </div>
        <div class="monitoringBus__report__wrapper__pagination" v-if="!loadingListing && !isEmpty" >
          <span>Page {{ page }} of {{ max_page }}</span>
          <i class="adx-ic_chevron_down" @click.stop="pageDown()"></i>
          <i class="adx-ic_chevron_up" @click.stop="pageUp()"></i>
        </div>
      </div>
      
    </div>
    <!-- Third Content -  Issue List -->
    <!-- <div class="monitoringBus__issue">
      <div class="monitoringBus__issue__title">
        <h1 class="medium-title bold">Issue List</h1>
      </div>
      <div class="monitoringBus__issue__content">
        <div>
          <table>
            <thead class="none">
              <tr>
                <td class="issue header-1">ISSUE ID</td>
                <td class="issue header-2">BUS</td>
                <td class="issue header-3">ISSUE</td>
                <td class="issue header-4">DATE</td>
                <td class="issue header-5">STATUS</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items_issue" :key="index" class="content">
                <td class="id">{{item.id}}</td>
                <td class="location">
                  <div class="location__wrapper">
                    <div class="bold">{{item.location}}</div>
                    <div>{{item.placement}}</div>
                  </div>
                </td>
                <td class="issue_desc">{{item.issue}}</td>
                <td class="date">{{item.date}}</td>
                <td class="status">{{item.status}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Empty from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import SelectDropdown from '@/components/Form/SelectDropdown'
import LabelStatus from '@/components/StatusLabel'
import ListItem from '@/components/ListDemographic'
import Modal from '@/components/Modal'


import api from '@/api'
import axios from 'axios'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'
import {gmapApi} from 'vue2-google-maps'
import { mapGetters } from 'vuex';

export default {
  name: 'adx-dashboard-campaign-detail',
  components: {
    'adx-empty': Empty,
    'adx-loading': Loading,
    'adx-selectdropdown': SelectDropdown,
    'adx-labelstatus': LabelStatus,
    'adx-list-item': ListItem,
    'adx-modal': Modal,
  },
  props: {

  },
  data() {
    return {
      intervalid:'',
      id: null,
      bus_icon: {
        url: '/img/bus/bus_icon_green.png',
        scaledSize: {width: 50, height: 50}
      },
      campaign_title: null,
      last_item: 0,
      loadingListing: false,
      max_page: 0,
      page : 0,
      selectedVehicle: 'value_1',
      selectedMarker: null,
      busStatus: {
        in_service: 0,
        off_service: 0,
        out_of_service: 0,
        total_bus: 0
      },
      markers: [],
      listingDisplayed: [],
      listingTotal: [],
      markersDummy : [
        {
          window_open: false,
          label: 'B 6778 SAB',
          value: 'value_1',
          speed: 30,
          distance: 20,
          odometer: 101112,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.220167,
              lng: 106.663045
            },
        },
        {
          window_open: false,
          label: 'B 6779 SAB',
          value: 'value_2',
          speed: 31,
          distance: 22,
          odometer: 75879,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.235584,
              lng: 106.627511
            },
        },
        {
          window_open: false,
          label: 'B 6780 SAB',
          value: 'value_3',
          speed: 34,
          distance: 20,
          odometer: 10000,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.150827,
              lng: 106.815928
            }
        },
        {
          window_open: false,
          label: 'B 6781 SAB',
          value: 'value_4',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.196334,
              lng: 106.828839
            },
        },
        {
          window_open: false,
          label: 'B 6782 SAB',
          value: 'value_5',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.155745,
              lng: 106.708481
            },
        },
        {
          window_open: false,
          label: 'B 6783 SAB',
          value: 'value_6',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.187614,
              lng: 106.739386
            },
        },
        {
          window_open: false,
          label: 'B 6784 SAB',
          value: 'value_7',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.210076,
              lng: 106.764015
            },
        },
        {
          window_open: false,
          label: 'B 6785 SAB',
          value: 'value_8',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Blok M - Soekarno Hatta',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat:-6.151057,
              lng: 106.891662
            },
        },
        {
          window_open: false,
          label: 'B 6786 SAB',
          value: 'value_9',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Bekasi Timur  -  Botani Square',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.223782,
              lng: 106.843384
            },
        },
        {
          window_open: false,
          label: 'B 6787 SAB',
          value: 'value_10',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Bekasi Timur  -  Botani Square',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.130398,
              lng: 106.827755
            },
        },
        {
          window_open: false,
          label: 'B 6788 SAB',
          value: 'value_11',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Bekasi Timur  -  Botani Square',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: -6.166380,
              lng: 106.878432
            },
        }
      ],
      // items_issue:[
      //   {
      //     id: '32198',
      //     location: 'B 6778 SAB',
      //     placement: 'Bekasi Timur  -  Botani Square',
      //     issue: 'Delivery Problem',
      //     date: '19 Apr 2019 at 21.00',
      //     status: 'On Progress'
      //   },
      //   {
      //     id: '32197',
      //     location: 'C 6778 GAB',
      //     placement: 'Blok M - Soekarno Hatta',
      //     issue: 'Delivery Problem',
      //     date: '19 Apr 2019 at 21.00',
      //     status: 'On Progress'
      //   }
      // ],
    }
  },
  computed: {
    ...mapGetters({
        user: 'account',
        token: 'token'
    }),
    google: gmapApi,
    isEmpty: function(){
      return this.listingTotal.length <= 0
    },
  //   icon(){
  //    let baseIcon = {
  //      path: '/img/bus.png',
  //    }
  //    if(this.googleMapsInitialized){

  //     baseIcon.scaledSize = new window.google.maps.Size(30, 30)
  //    }
  //    return baseIcon;
  //  }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.id = this.$route.params.id;
    this.campaign_title = this.$route.params.campaign
  },
  async mounted() {
    // this.loadData()
    await this.loadVehicles()
    await this.loadBusStatus()
    await this.loadBusPosition()
    this.intervalid = setInterval(() => {
        this.loadBusPosition()
        // console.log('load position');
    }, 10000);
    // loaded.then(()=>{
    //   this.googleMapsInitialized = true; // define this property in data
    // });
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {
    clearInterval(this.intervalid)
  },
  destroyed() {

  },
  methods: {
    async loadVehicles() {
      this.loadingListing = true
      const { data } = await api.get(apiV2.busMonitoring(this.$route.params.id), { needToken: true});
      if(data){
        this.listingTotal = await data.map(x => {
          let value = 'active'
          switch (x.status) {
            case 'in service':
              value = 'active'
              break;

            case 'off service':
              value = 'warning'
              break
          
            default:
              value = 'outofservice'
              break;
          }
          let status = x.status.toUpperCase()
          return {
            ...x,
            status: {'label': status, 'value': value}
          }
        })

        this.listingTotal.sort((a, b) => {
          let orderingRule = ['active', 'warning', 'outofservice']
          return orderingRule.indexOf(a.status.value) - orderingRule.indexOf(b.status.value)
        })
      }
      if (this.listingTotal.length > 0) this.page = 1
      this.getDisplayedContents()
      this.loadingListing = false
    },
    async loadBusPosition() {
      const vehicles = this.listingTotal.map(x => x.vehicle_id)
      const { data } = await api.post(apiV2.busMonitoringPosition(this.$route.params.id), {bus_id: vehicles} , { needToken: true});
      this.markers = data.map(x => {
        return {
          window_open: false,
          label: x.BusId,
          value: 'value_11',
          speed: 30,
          distance: 20,
          odometer: 10,
          poi: 'Pool Kp. Rambutan',
          route: 'Bekasi Timur  -  Botani Square',
          placement: 'Full Body',
          status: { 'label': 'NORMAL', 'value': 'active'},
          position:
            {
              lat: parseFloat(x.Lat),
              lng: parseFloat(x.Lon)
            }
        }
      })
    },
    async loadBusStatus() {
      const { data }  = await api.get(apiV2.busMonitoringStatus(this.$route.params.id), { needToken: true});
      // const data = await axios.get(`http://localhost:5000/bus_monitoring/campaign/5/vehicles/status`,
      // {data: {}});
      this.busStatus = data
      // console.log('bus', data)
    },
    loadData(){
      this.markers = this.markersDummy
      this.getDisplayedContents()
    },
    showTooltip (m, index, isShow) {
      this.selectedMarker = this.markers[index]
      this.markers[index].window_open = isShow
    },
    goToAllCampaign(){
      this.$router.push({ name: 'monitoringbuscampaign' })
    },
    getDisplayedContents(){
      let len = this.listingTotal.length

      let max_item = 15
      this.max_page = Math.ceil(len/max_item)
      this.last_item = this.page < this.max_page ? this.page * max_item : len
      let first_item = ((this.page - 1) * max_item)
      this.listingDisplayed = this.listingTotal.slice(first_item, this.last_item)
    },
    pageUp(){
      if (this.page > 1) {
        this.page -= 1
      } else {
        this.page = this.max_page
      }
      this.getDisplayedContents()
    },
    pageDown(){
      if (this.page < this.max_page) {
        this.page += 1
      } else {
        this.page = 1
      }
      this.getDisplayedContents()
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>

<style lang='scss'>
.monitoringBus{

  &__report__wrapper__table__content {
    .dropdownDoc__item {
      .label {
        margin: 0px;
      }
    }
  }
  .gm-style-iw{
    button{
      display: none !important;
    }
  }

  .gm-style .gm-style-iw-c, .gm-style .gm-style-iw-d, .gm-style .gm-style-iw-t::after {
    background: #262626;
  }

  .gm-style-iw-d{
    div{
      .pop-up{
        background: #262626;
        .detail{
          &__speed {
            margin-top: 10px;
            margin-bottom: 10px;
          }
          &__odometer {
            &__label {
              margin-right: 5px;
            }
          }
          &__distance {
            &__label {
              margin-right: 5px;
            }
          }
          &__poi {
            &__label {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }


  .gm-style .gm-style-iw-c .gm-style-iw-d::-webkit-scrollbar-corner, 
  .gm-style .gm-style-iw-d::-webkit-scrollbar-track, 
  .gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece{
    background: #262626;
  }

  .poi-info-window div, .poi-info-window a{
    color: white;
    font-family: Roboto,Arial;
    background: #262626;
  }

  .view-link{
    span{
      color: wheat;
    }
  }
}
</style>